import { alpha, borderRadius } from "@mui/system";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    padding: 0,
  },
  boxHeader: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
  },
  searchField: {
    width: "300px",
  },
  searchAndCardsContainer: {
    mb: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    flexWrap: "wrap",
    gap: 2,
  },
  globalCardContainer: {
    display: "flex",
    gap: 1,
    flexWrap: "wrap",
  },
  globalCard: {
    display: "flex",
    alignItems: "center",
    gap: 1.5,
    px: 2,
    py: 0.75,
    borderRadius: "12px",
    transition: "all 0.2s ease-in-out",
  },
  globalCardIconBox: {
    width: 32,
    height: 32,
    borderRadius: "8px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  globalCardTitle: {
    fontWeight: 600,
    color: "text.secondary",
    display: "block",
    lineHeight: 1,
  },
  globalCardValueBox: {
    display: "flex",
    alignItems: "baseline",
    gap: 0.5,
  },
  globalCardPercent: {
    fontWeight: "bold",
    color: "text.primary",
  },
  globalCardCount: {
    color: "text.secondary",
    fontSize: "0.65rem",
  },
  filterContainer: {
    display: "flex",
    alignItems: "center",
    gap: 2,
    mb: "10px",
  },
  bulkActionBar: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 24px",
    borderRadius: "16px",
    marginBottom: "16px",
    background: alpha(theme.palette.background.wallpaper, 0.5),
   
    border: "1px solid",
    borderColor: theme.palette.mode === 'dark' ? "rgba(255, 255, 255, 0.1)" : "rgba(255, 255, 255, 0.6)",
    
  },
  boxDataGrid: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    borderRadius: "16px",
    p: 2,
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  boxGrupoCliente: {
    display: "flex",
    alignItems: "center",
    gap: 0.5,
    overflow: "hidden",
  },
  chipGrupoCliente: {
    fontSize: "0.72rem",
    height: "22px",
    fontWeight: 500,
    "& .MuiChip-label": { px: 1 },
  },
  chipOthers: {
    fontSize: "0.7rem",
    height: "20px",
    minWidth: "24px",
    cursor: "pointer",
    fontWeight: "bold",
  },
  containerDatagridGrupos: {
    display: "flex",
    justifyItems: "start",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    maxWidth: "230px",
    gap: 0.5,
    overflow: "hidden",
    minWidth: 0,
  },
  buttonGrupo: {
    width: "100%",
    display: "flex",
    justifyContent: "start",
    maxWidth: "160px",
    minHeight: "100%",
    p: "1px 4px",
    textTransform: "none",
  },
  chipGrupo: {
    margin: "3px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
    color: theme.palette.white.main,
    fontSize: "0.7rem",
    minWidth: 0,
  },
  chipCount: {
    height: 18,
    fontSize: "0.65rem",
    color: theme.palette.white.main,
    fontWeight: "bold",
    backgroundColor: "chip.main.arquive",
  },
  textNoGrupo: {
    fontSize: "0.63rem",
    fontWeight: 500,
    fontWeight: "bold",
  },
  paperContent: {
    borderRadius: "16px",
    backgroundColor: theme.palette.mode === "dark" && "transparent",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    margin: 0,
    padding: "20px",
  },
  paperDatagrid: {
    width: "100%",
    overflowX: "auto",
    backgroundColor: theme.palette.background.paper,
    borderRadius: "16px",
    padding: "20px",
  },
  title: { fontWeight: "bold", fontSize: "20px", mb: 2 },
  listContentMobile: {
    width: "100%",
    padding: 0,
  },
  paperSupContainer: {
    padding: "20px",
    borderRadius: "16px",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    width: "100%",
    background:
      theme.palette.mode === "dark"
        ? theme.palette.background.modalContrast
        : theme.palette.colors.black.lighter,
  },
  boxList: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "5px",
  },
  chip: {
    padding: "5px",
    fontSize: "10px",
    textAlign: "center",
    width: "100px",
    position: "absolute",
    marginLeft: "50%",
    height: "auto",
    color: theme.palette.white.main,
    "& .MuiChip-label": {
      display: "block",
      whiteSpace: "normal",
    },
  },

  notificacoesBox: {
    display: "flex",
    flexDirection: "column",
    maxHeight: "287.6px",
    overflow: "auto",
    padding: 1,
    gap: 1,
  },
  notificacoesMobileBadge: { zIndex: "0" },
  listItens: {
    display: "flex",
    flexDirection: "row",
    padding: 0,
  },
  containerListItens: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    padding: "16px 0 0 16px",
    minHeight: "135px",
  },
  containerMenuMobile: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
  },
  menuItensMobile: {
    minWidth: "250px",
    display: "flex",
    alignItems: "center",
  },
  iconButton: {
    bgcolor: "background.paper",
    borderRadius: 0,
    height: "135px",
    ":focus": {
      bgcolor: "background.paper",
    },
  },
  containerNameRazaoSocial: {
    width: "100%",
    maxWidth: "165px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  nomeFantasia: {
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    display: "block",
  },
  dataGrid: {
    display: "grid",
    "& .MuiDataGrid-cell:focus-within, & .MuiDataGrid-cell:focus": {
      outline: "none !important",
    },
    "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
      pt: "5px",
    },
    "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
      py: "10px",
    },
    "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
      py: "15px",
    },
  },
  launchIcon: {
    cursor: "pointer",
  },
  tagsContainer: {
    display: "flex",
    justifyItems: "start",
    alignItems: "center",
    flexWrap: "wrap",
    width: "100%",
    gap: 0.5,
    minWidth: 0,
  },
  tagChipVisible: {
    // margin: "3px",
    overflow: "hidden",
    whiteSpace: "nowrap",
    textOverflow: "ellipsis",
    fontWeight: "bold",
    color: theme.palette.white.main,
    fontSize: "0.7rem",
    height: 20,
  },
  tagCounterChip: {
    height: 18,
    fontSize: "0.65rem",
    color: theme.palette.white.main,
    fontWeight: "bold",
    backgroundColor: "chip.main.arquive",
    cursor: "pointer",
  },
});

export default styles;
